// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_tTk-e","container":"container_jtvNo","wrapper":"wrapper_R0rG7"};